// Fetch the 'modules' document from the 'settings' collection in Firestore
export const getAllModules = async ($fire: any) => {
  return await $fire.firestore.collection('settings').doc('modules').get()
}
